import './ConfigMetadataModal.scss';
import { useState } from 'react';
import { Form, Modal } from 'react-bootstrap';
import { Button } from '../../Components/Button';
import { Appearance, Design } from '../../Components/designConstants';

interface EditConfigMetadataModalProps {
  onHide: () => void;
  onSave: (newName: string, newDescription: string) => void;
  currentName: string;
  currentDescription: string;
}

export const EditConfigMetadataModal = ({
  onHide,
  onSave,
  currentName,
  currentDescription
}: EditConfigMetadataModalProps) => {
  const [newName, setNewName] = useState(currentName);
  const [newDescription, setNewDescription] = useState(currentDescription);

  return (
    <Modal
      className='config-metadata-modal'
      data-testid='config-metadata-modal'
      show
      onHide={onHide}
    >
      <Modal.Header>
        <Modal.Title>Edit Deck Name and Description</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className='config-metadata-modal-label'>Deck Name</div>
        <Form.Control
          data-testid='config-metadata-name-input'
          className='config-metadata-modal-input'
          onChange={e => setNewName(e.target.value)}
          value={newName}
        />
        <div className='config-metadata-modal-label'>Deck Description (optional)</div>
        <Form.Control
          as='textarea'
          rows={3}
          data-testid='config-metadata-description-input'
          className='config-metadata-modal-input'
          onChange={e => setNewDescription(e.target.value)}
          value={newDescription}
        />
      </Modal.Body>
      <Modal.Footer className='config-metadata-modal-footer'>
        <Button appearance={Appearance.OUTLINED} design={Design.NEUTRAL} onClick={onHide}>
          Cancel
        </Button>
        <Button onClick={() => onSave(newName, newDescription)}>Save</Button>
      </Modal.Footer>
    </Modal>
  );
};
